import React, { useState, useEffect } from "react";

const Device = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
   
    const checkIfMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)) {
        setIsMobile(true); 
      } else {
        setIsMobile(false); 
      }
    };

    checkIfMobile();
  }, []);

  const handleButtonClick = () => {
    window.location.href = "https://app.phaver.com/DvjcmYCvkF5D37xv5";
  };

  return (
    <div>
      <button onClick={handleButtonClick} disabled={!isMobile} className="btn btn-success" type="button">Follow me on Phaver!
      </button>
      {!isMobile && <p className="text-danger">This button is only active on mobile devices.</p>}
    </div>
  );
};

export default Device;
